import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './core/auth';

import { DashboardComponent } from './dashboard/dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { LayoutComponent } from './core/layout/layout.component';

import { TrainWizardComponent } from './training/train-wizard/train-wizard.component';

const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'logout',
        component: LogoutComponent,
    },
    {
        path: '',
        component: LayoutComponent,
        children: [
            // AUTHENTICATED ROUTES
            {
                path: '',
                canActivateChild: [AuthGuard],
                children: [
                    { path: 'dashboard', component: DashboardComponent },
                    { path: 'training/:id', component: TrainWizardComponent },
                    { path: '**', redirectTo: 'dashboard', data: { redirectType: 'catch-all' } },
                ],
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
